import PropTypes from "prop-types"

import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"

const ProductPrice = ({ product }) => {
  const onSale = product.reg !== product.selling

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${product.reg}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.selling}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${product.reg}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }

  return (
    <p className="body-sm desktop:mb-6 mb-4" {...globaleAttrs.container}>
      {IS_JEWLR() ? (
        <>
          from{" "}
          {onSale ? (
            <>
              <span
                className="text-emerald font-semibold"
                data-cy={`collection-product-price-${product.style_code}`}
                {...globaleAttrs.display}
              >
                {to_currency(product.selling, { precision: 0 })}
              </span>
              <strike
                className="text-grey-300 mx-6 font-semibold"
                {...globaleAttrs.reg}
              >
                {to_currency(product.reg, { precision: 0 })}
              </strike>
              <span className="mobile:inline text-emerald block font-semibold">
                SAVE{" "}
                {(
                  ((product.reg - product.selling) / product.reg) *
                  100
                ).toFixed(0)}
                %
              </span>
            </>
          ) : (
            <span
              className="font-semibold"
              data-cy={`collection-product-price-${product.style_code}`}
              {...globaleAttrs.display}
            >
              {to_currency(product.reg, { precision: 0 })}
            </span>
          )}
        </>
      ) : (
        <span
          className="text-emerald"
          data-cy={`collection-product-price-${product.style_code}`}
        >
          {to_currency(product.selling, { precision: 0 })}
        </span>
      )}
    </p>
  )
}

ProductPrice.propTypes = {
  product: PropTypes.object,
}

export default ProductPrice
